import { MoneyDTO } from "../apiclient/ApiDtos";

export default class BillingBreakdown {
    public subtotal: MoneyDTO;
    public discount: MoneyDTO;
    public convenienceFee: MoneyDTO;
    public tax: MoneyDTO;
    public total: MoneyDTO;

    constructor(subtotal: MoneyDTO, discount?: MoneyDTO|null, convenienceFee?: MoneyDTO|null, tax?: MoneyDTO|null) {
        this.subtotal = subtotal;
        this.discount = discount? discount : this.zeroAmount(subtotal.currency);
        this.convenienceFee = convenienceFee? convenienceFee : this.zeroAmount(subtotal.currency);
        this.tax = tax? tax : this.zeroAmount(subtotal.currency);
        this.total = this.calcualteTotal();
    }

    withDiscount(discount: MoneyDTO) {
        return new BillingBreakdown(this.subtotal, discount, this.convenienceFee, this.tax);
    }

    withoutDiscount() {
        return new BillingBreakdown(this.subtotal, this.zeroAmount(this.subtotal.currency), this.convenienceFee, this.tax);
    }

    private zeroAmount(currency:"MMK"|"USD"):MoneyDTO {
        return {
            currency: currency,
            amount: 0
        };
    }

    private calcualteTotal():MoneyDTO {
        return {
            currency: this.subtotal.currency,
            amount: this.subtotal.amount + 
                (this.convenienceFee? this.convenienceFee.amount: 0) + 
                (this.tax? this.tax.amount: 0) - 
                (this.discount? this.discount.amount: 0)
        }
    }

    
}